/* src/app/components/date-range-picker/date-range-picker.component.scss */
.date-range-picker {
  display: flex;
}
@media screen and (max-width: 739px) {
  .date-range-picker {
    gap: 15px;
    justify-content: center;
  }
}
@media screen and (min-width: 740px) {
  .date-range-picker {
    flex-direction: column;
    align-items: flex-start;
    width: 240px;
  }
}
.date-range-picker .date {
  margin-bottom: 17px;
}
.date-separator {
  display: none !important;
}
@media (max-width: 739px) {
  .wide-screen {
    display: none;
  }
}
@media (min-width: 740px) {
  .small-screen {
    display: none;
  }
}
@media (min-width: 1280px) {
  .date-range-picker {
    width: 346px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  .date-range-picker .date {
    margin-bottom: auto;
  }
  .date-separator {
    position: relative;
    margin-top: 2.35rem;
    margin-bottom: auto;
    display: flex !important;
  }
}
@media (min-width: 1880px) {
  .date-range-picker {
    width: 377px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  .date-range-picker .date {
    margin-bottom: auto;
  }
  .date-separator {
    position: relative;
    margin-top: 2.35rem;
    margin-bottom: auto;
    display: flex !important;
  }
}
::ng-deep .date-picker-wrapper {
  max-width: 160px;
}
::ng-deep .date-picker-wrapper small {
  display: flex;
  max-width: 160px;
}
/*# sourceMappingURL=date-range-picker.component.css.map */
